<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: "adminWrapper"
};
</script>

<style scoped></style>
